import React from 'react';
import { SectionHeading } from '../product/SectionHeading';
import type { SolutionStep } from '../../types/solution';
type JourneyTimelineProps = {
  heading: string;
  subheading: string;
  items: SolutionStep[];
};
const colClass: Record<number, string> = {
  3: 'lg:grid-cols-3',
  4: 'lg:grid-cols-4',
  5: 'lg:grid-cols-5'
};
export function JourneyTimeline({
  heading,
  subheading,
  items
}: JourneyTimelineProps) {
  return <section className="w-full bg-canvas-sky py-20" aria-labelledby="journey-heading" data-id="element-1511" data-mp="30rs6yj4o73oi">
      <div className="mx-auto max-w-shell px-6" data-id="element-1512" data-mp="35kbsc29ln33v">
        <SectionHeading id="journey-heading" title={heading} subtitle={subheading} data-id="element-1513" data-mp="35l4vkt9cnah9" />
        <ol className={`mt-14 grid grid-cols-1 lg:gap-6 ${colClass[items.length] ?? 'lg:grid-cols-5'}`} data-id="element-1514" data-mp="2rpsnzla3hpix">
          {items.map((step, index) => {
          const last = index === items.length - 1;
          return <li key={step.title} className="relative flex gap-5 pb-10 last:pb-0 lg:flex-col lg:gap-0 lg:pb-0" data-id="element-1515" data-mp="2mssq3xneft2w" data-mpi={index}>
                {!last && <span aria-hidden="true" className="absolute bottom-0 left-[17px] top-9 w-px bg-ink/10 lg:left-9 lg:right-[-24px] lg:top-[18px] lg:h-px lg:w-auto" data-id="element-1516" data-mp="217pwm9y7clxo" />}
                <span className="relative z-[1] flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand text-[14px] font-semibold text-white ring-4 ring-canvas-warm" data-id="element-1517" data-mp="2a7cz6z2o3xsb">
                  {index + 1}
                </span>
                <div className="lg:mt-5 lg:pr-2" data-id="element-1518" data-mp="1dk9fm3ge0dm1">
                  {step.time && <p className="text-[13px] font-semibold tabular-nums text-brand" data-id="element-1519" data-mp="1dhnb6cosme81">{step.time}</p>}
                  <h3 className={`text-[18px] font-semibold tracking-[-0.02em] text-ink ${step.time ? 'mt-1' : ''}`} data-id="element-1520" data-mp="1rcpjf6h44fo0">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-[14.5px] leading-[1.55] text-ink-muted" data-id="element-1521" data-mp="ysr3whuk958h">{step.copy}</p>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}